import { render, staticRenderFns } from "./CreateSplitWallet.vue?vue&type=template&id=a88553d6&scoped=true"
import script from "./CreateSplitWallet.vue?vue&type=script&lang=js"
export * from "./CreateSplitWallet.vue?vue&type=script&lang=js"
import style0 from "./CreateSplitWallet.vue?vue&type=style&index=0&id=a88553d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88553d6",
  null
  
)

export default component.exports